import { getLogger, type PlainValue } from '@/logger/logger';

const logger = getLogger('feature-flags');

type FeatureFlagFacts = {
  event: string;
  flag_key?: string;
  adapter?: string;
  variant?: string | null;
  enabled?: boolean;
  match?: boolean;
  is_fallback?: boolean;
  value_keys?: readonly string[];
  attempt?: number;
  max_attempts?: number;
  evaluation_id?: string | null;
  source?: string;
  [key: string]: PlainValue;
};

type FeatureFlagLogMeta = {
  feature_flag: FeatureFlagFacts;
  user?: { id: string };
  duration?: number;
  error?: unknown;
};

export function logError(
  message: string,
  error: unknown,
  meta?: FeatureFlagLogMeta,
) {
  logger.error(message, { ...meta, error });
}

export function logInfo(message: string, meta?: FeatureFlagLogMeta) {
  logger.info(message, meta);
}

export function logWarning(message: string, meta?: FeatureFlagLogMeta) {
  logger.warn(message, meta);
}

export function logDebug(message: string, meta?: FeatureFlagLogMeta) {
  logger.debug(message, meta);
}
